const attach = require('./attach');

module.exports = attach(global);



// WEBPACK FOOTER //
// ./src/node.js